export const RELEVANCE_CATEGORY_LIST: Record<string, string> = {
  veryLow: 'Very low',
  low: 'Low',
  moderate: 'Moderate',
  high: 'High',
  veryHigh: 'Very high',
};

export const DEFAULT_RELEVANCE_SCORE_FILTER_VALUE = Object.values(RELEVANCE_CATEGORY_LIST);

export const RELEVANCE_NAME_TO_TRANSLATION_KEY: Record<string, string> = {
  [RELEVANCE_CATEGORY_LIST.veryLow]: 'very-low',
  [RELEVANCE_CATEGORY_LIST.low]: 'low',
  [RELEVANCE_CATEGORY_LIST.moderate]: 'moderate',
  [RELEVANCE_CATEGORY_LIST.high]: 'high',
  [RELEVANCE_CATEGORY_LIST.veryHigh]: 'very-high',
};

// Upper bound of exact total hits count.
export const RELEVANCE_SCORE_TO_NAME: Record<number, string> = {
  0: RELEVANCE_CATEGORY_LIST.veryLow,
  1: RELEVANCE_CATEGORY_LIST.low,
  2: RELEVANCE_CATEGORY_LIST.low,
  3: RELEVANCE_CATEGORY_LIST.moderate,
  4: RELEVANCE_CATEGORY_LIST.moderate,
  5: RELEVANCE_CATEGORY_LIST.moderate,
  6: RELEVANCE_CATEGORY_LIST.high,
  7: RELEVANCE_CATEGORY_LIST.high,
  8: RELEVANCE_CATEGORY_LIST.high,
  9: RELEVANCE_CATEGORY_LIST.high,
  10: RELEVANCE_CATEGORY_LIST.high,
  11: RELEVANCE_CATEGORY_LIST.veryHigh,
  12: RELEVANCE_CATEGORY_LIST.veryHigh,
  13: RELEVANCE_CATEGORY_LIST.veryHigh,
  14: RELEVANCE_CATEGORY_LIST.veryHigh,
  15: RELEVANCE_CATEGORY_LIST.veryHigh,
  16: RELEVANCE_CATEGORY_LIST.veryHigh,
  17: RELEVANCE_CATEGORY_LIST.veryHigh,
  18: RELEVANCE_CATEGORY_LIST.veryHigh,
  19: RELEVANCE_CATEGORY_LIST.veryHigh,
  20: RELEVANCE_CATEGORY_LIST.veryHigh,
  21: RELEVANCE_CATEGORY_LIST.veryHigh,
  22: RELEVANCE_CATEGORY_LIST.veryHigh,
  23: RELEVANCE_CATEGORY_LIST.veryHigh,
  24: RELEVANCE_CATEGORY_LIST.veryHigh,
  25: RELEVANCE_CATEGORY_LIST.veryHigh,
  26: RELEVANCE_CATEGORY_LIST.veryHigh,
  27: RELEVANCE_CATEGORY_LIST.veryHigh,
  28: RELEVANCE_CATEGORY_LIST.veryHigh,
  29: RELEVANCE_CATEGORY_LIST.veryHigh,
  30: RELEVANCE_CATEGORY_LIST.veryHigh,
  31: RELEVANCE_CATEGORY_LIST.veryHigh,
  32: RELEVANCE_CATEGORY_LIST.veryHigh,
  33: RELEVANCE_CATEGORY_LIST.veryHigh,
  34: RELEVANCE_CATEGORY_LIST.veryHigh,
  35: RELEVANCE_CATEGORY_LIST.veryHigh,
  36: RELEVANCE_CATEGORY_LIST.veryHigh,
  37: RELEVANCE_CATEGORY_LIST.veryHigh,
  38: RELEVANCE_CATEGORY_LIST.veryHigh,
  39: RELEVANCE_CATEGORY_LIST.veryHigh,
  40: RELEVANCE_CATEGORY_LIST.veryHigh,
};

export const RELEVANCE_NAME_TO_SCORE = Object.keys(RELEVANCE_SCORE_TO_NAME).reduce((acc, score) => {
  const scoreInteger = Number(score);

  if (!acc[RELEVANCE_SCORE_TO_NAME[scoreInteger]]) {
    acc[RELEVANCE_SCORE_TO_NAME[scoreInteger]] = [];
  }
  acc[RELEVANCE_SCORE_TO_NAME[scoreInteger]].push(scoreInteger);

  return acc;
}, {} as Record<string, number[]>);
